import React from 'react';
import PropTypes from 'prop-types';
import { Grid, makeStyles } from '@material-ui/core';
import { useAtom } from 'jotai';
import { isIOSDeviceAtom } from 'Atoms/Ticket';

const useStyles = makeStyles((theme) => ({
  root: {
    background: 'white',
    padding: '1rem 0',
    bottom: 0,
    borderRadius: '30px 30px 0 0',
    boxShadow: '0 -2px 20px rgba(0, 0, 0, 0.1)',
    width: '100%',
  },
  sticky: {
    position: 'sticky',
    position: '-webkit-sticky' /* Safari */,
    marginBottom: '-57px',
    bottom: 0,
  },
  fixed: {
    position: 'fixed',
  },
  hide: {
    display: 'none',
  },
}));
const BottomContainerAction = ({ hide, children }) => {
  const classes = useStyles();
  const [isIOSDevice] = useAtom(isIOSDeviceAtom);

  return (
    <Grid
      container
      justifyContent="center"
      className={`${classes.root} ${
        isIOSDevice ? classes.sticky : classes.fixed
      } ${hide ? classes.hide : ''}`}
    >
      <Grid item xs={11}>
        {children}
      </Grid>
    </Grid>
  );
};

BottomContainerAction.propTypes = {
  children: PropTypes.node,
};

export default BottomContainerAction;
